import { render, staticRenderFns } from "./AcademyBranchList.vue?vue&type=template&id=48e350de&scoped=true&lang=pug&"
import script from "./AcademyBranchList.vue?vue&type=script&lang=ts&"
export * from "./AcademyBranchList.vue?vue&type=script&lang=ts&"
import style0 from "./AcademyBranchList.vue?vue&type=style&index=0&id=48e350de&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e350de",
  null
  
)

export default component.exports